module.exports = __webpack_public_path__ + "img/gad_nougaro.4952e130.jpg";